

function fetchRequest(key) {
	return {
		url: `/morty/assistant/request/${key}`,
		method: 'GET'
	};
}



export {  fetchRequest  };
